import { useHover } from "@lib/utils/useHover";
import type { VariationPlacement } from "@popperjs/core";
import clsx from "clsx";
import { ReactNode } from "react";
import { Popper } from "./Popper";

export type TooltipProps = {
  title?: ReactNode;
  placement?: VariationPlacement;
  flip?: boolean;
  clickable?: boolean;
  inlineBlock?: boolean;
  disabled?: boolean;
  className?: string;
  titleClassName?: string;
  popperClassName?: string;
  onShow?: () => void;
  onHide?: () => void;
  children?: ReactNode;
};

export const Tooltip = ({
  title,
  placement = "bottom-start",
  flip = true,
  clickable = false,
  disabled = false,
  titleClassName,
  popperClassName,
  onShow,
  onHide,
  children,
  className,
}: TooltipProps) => {
  const { hover, everHovered, anchorEl, eventHandlers } = useHover({
    onEnter: onShow,
    onLeave: onHide,
  });

  if (!title) return <>{children}</>;

  return (
    <span
      className={clsx(
        /*classes.root,*/
        className,
      )}
      {...eventHandlers}
    >
      {/* Only render the Popper if this element has ever been hovered. (But
         keep it in the React tree thereafter, so it can remember its state and
         can have a closing animation if applicable. */}
      {everHovered && (
        <Popper
          placement={placement}
          open={hover && !disabled}
          anchorEl={anchorEl}
          allowOverflow={!flip}
          clickable={clickable}
          className={popperClassName}
        >
          <div
            className={clsx(
              "relative p-1.5 text-sm bg-stone-100 dark:bg-[#181818] text-stone-800 dark:text-stone-100 border border-gray-500 border-opacity-30 max-w-[300px] z-10001",
              titleClassName,
            )}
          >
            {title}
          </div>
        </Popper>
      )}

      {children}
    </span>
  );
};
